var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"}}),_c('line',{attrs:{"x1":"7","y1":"7","x2":"7.01","y2":"7"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }